<template>
    <select class="form-control font-weight-bold"  id="selecComision" v-model="valor"  @change="$emit('evento', valor)">
        <option value="">Seleccione tipo de comisión...</option>
        <option v-for="d in $store.state.dataComisionChip" :key="d.Id" :value="d.Id"  >{{d.comision+' - '+d.monto}}</option>
    </select>
</template>

<script>
export default {
    name:"SelectComision",
    props:['valor_entrada'],
     data(){
        return{
            valor:'',
            data:[]
            }
        },
         beforeMount() {
            // this.obtenerSede();
            if(this.valor_entrada!=undefined && this.valor_entrada!='000'){
                this.valor=parseInt(this.valor_entrada);
            }else{
                 this.valor='';
            }
        },
    created(){
      this.data=this.$store.state.dataComisionChip;
    },
      watch: {
            valor_entrada(newQuestion, oldQuestion) {
                this.valor=newQuestion;
            }
        }

}
</script>

